import { makeStyles } from '@mui/styles';
const BORDER = '1px solid #e0e0e0';
const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    // Never wider than the screen: the modal stays usable on a narrow window.
    minWidth: 'min(520px, 100%)',
    maxWidth: 640
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '24px 0'
  },
  picker: {
    width: '100%'
  },
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
  },
  // ── Sections of a portfolio bill (LB-5910) ────────────────────────────────────────────────
  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    maxHeight: '52vh',
    overflowY: 'auto',
    paddingRight: 4
  },
  progress: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  progressText: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  progressCount: {
    fontWeight: 600
  },
  progressBar: {
    height: 6,
    borderRadius: 3
  },
  section: {
    border: BORDER,
    borderRadius: 8,
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  sectionMatched: {
    backgroundColor: '#f7faf8'
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10
  },
  sectionStatus: {
    display: 'flex',
    paddingTop: 2,
    flexShrink: 0
  },
  sectionTitle: {
    flex: 1,
    minWidth: 0
  },
  sectionAddress: {
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  sectionAmount: {
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap'
  },
  sectionMatchedTo: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginLeft: 30
  },
  sectionChoice: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    marginLeft: 30
  },
  useForRest: {
    paddingLeft: 0,
    textTransform: 'none'
  },
  // ── Rules and actions ─────────────────────────────────────────────────────────────────────
  rules: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    borderTop: BORDER,
    paddingTop: 16
  },
  rulesHeading: {
    fontWeight: 600,
    marginBottom: 4
  },
  hint: {
    marginLeft: 32
  },
  serviceField: {
    marginLeft: 32,
    marginTop: 4,
    maxWidth: 320,
    display: 'flex'
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingTop: 4
  },
  footerHint: {
    fontStyle: 'normal'
  },
  actions: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap'
  }
});
export default useStyles;